import { NgModule } from '@angular/core';
import { FooterLinkComponent } from './footer-link.component';

@NgModule({
  declarations: [FooterLinkComponent],
  exports: [FooterLinkComponent],
})
export class FooterLinkModule {}
